import Pardot from './pardot';
import IePolyfills from '../../src/scripts/iePolyfills';

window.IePolyfills = new IePolyfills();
window.Pardot = Pardot;

